//@flow
import React from 'react';
import PropTypes from 'prop-types';

const PdpRespTradeNegotiationModal = React.lazy(() =>
    import(/* webpackChunkName: "TradeNegotiationModalLoaderChunk" */ './PdpRespTradeNegotiationModal')
);

export function PdpRespTradeNegotiationModalLoader(props) {
    return (
        <React.Suspense fallback={null}>
            <PdpRespTradeNegotiationModal
                environment={props.environment}
                userId={props.userId}
                currency={props.currency}
            />
        </React.Suspense>
    );
}

PdpRespTradeNegotiationModalLoader.propTypes = {
    environment: PropTypes.object,
    userId: PropTypes.string,
    currency: PropTypes.string,
};
